<template>
  <div class="warp_contrainer">
      <div class="navCalss">| 财务账号</div>
      <el-button type="primary" class="addBt" @click="addBt">添 加</el-button>
    <!-- 表格部分 -->
      <div class="table">
        <el-table
          :data="accountList"
          border
          max-height="600px"
          style="width: 100%;">
          <el-table-column
            prop="accountName"
            label="收款账号名称"
            align="center"
            >
          </el-table-column>
          <el-table-column
            prop="contacts"
            label="负责人名称"
            align="center"
            >
          </el-table-column>
          <el-table-column
            prop="tel"
            align="center"
            label="负责人电话">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
          <template slot-scope="scope">
           <el-button type="text" @click="editBt(scope.row)">
            编辑
           </el-button>
          </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加新内容Dialog -->
      <el-dialog
       :title="title?'编 辑':'添 加'"
       :visible.sync="dialog"
       width="35%"
       @close="closeD"
       :modal-append-to-body='false'
       center>
        <!-- 表单区域 -->
         <el-form :model="ruleForm" :rules="rules" ref="RuleForm" label-width="120px" class="demo-ruleForm">
           <el-form-item label="收款账号名称" prop="accountName" >
              <el-input v-model="ruleForm.accountName" clearable></el-input>         
           </el-form-item>
           <el-form-item label="账号负责人" prop="contacts">
             <el-input v-model="ruleForm.contacts" clearable></el-input>
           </el-form-item>
           <el-form-item label="负责人电话" prop="tel">
             <el-input v-model="ruleForm.tel" type="number" clearable></el-input>
           </el-form-item>
         </el-form> 
         <template #footer>
           <span class="dialog-footer">
             <el-button @click="dialog = false">取 消</el-button>
             <el-button type="primary" @click="comfirmBt">确 定</el-button>
           </span>
         </template>
      </el-dialog>
  </div>
</template>

<script>
import * as charge from '../../api/charge'
export default {
  data(){
    return{
      title:true,
      accountList:[],
      ruleForm:
        {
          accountId:'',
          accountName:'',
          contacts:'',
          tel:''
        },
      rules:{
          accountName: [
            { required: true, message: '请输入收款账号名称', trigger: 'blur' },
            { min: 1, message: '请输入收款账号名称', trigger: 'blur' }
          ],
          contacts: [
            { required: true, message: '请输入账号负责人', trigger: 'blur' }
          ],
          tel: [
            { required: true, message: '请输入负责人电话', trigger: 'blur' }
          ],
      },
      dialog:false
    }
  },
  created(){
    this.getAccountList()
  },
  methods:{
    getAccountList(){
       let param={}
       charge.getAccountList(param).then(res =>{
         if(res.data.code!==0)
         return this.$message.error('获取账户列表失败')
         else {
           this.accountList=res.data.data.list
         }
       })
    },
    editBt(row){
      let arr=JSON.parse(JSON.stringify(row))
      this.$set(this.ruleForm,'accountId',arr.accountId)
      this.$set(this.ruleForm,'accountName',arr.accountName)
      this.$set(this.ruleForm,'contacts',arr.contacts)
      this.$set(this.ruleForm,'tel',arr.tel)
      this.title=true
      this.dialog=true
      // this.$nextTick(()=>{
      // this.$refs.RuleForm.resetFields();
      // })
    },
    addBt(){
      this.$set(this.ruleForm,'accountName','')
      this.$set(this.ruleForm,'contacts','')
      this.$set(this.ruleForm,'tel','')
      this.title=false
      this.dialog=true
      // this.$nextTick(()=>{
      // this.$refs.RuleForm.resetFields();
      // })
    },
    closeD(){
      this.$refs.RuleForm.resetFields();
    },
    comfirmBt(){
      var bool;
      let param={
        accountId:this.ruleForm.accountId,
        accountName:this.ruleForm.accountName,
        contacts:this.ruleForm.contacts,
        tel:this.ruleForm.tel
      }
      this.$refs.RuleForm.validate(vali=>{bool=vali});
      if(bool){
        if(this.title){
        charge.upDateAccountList(param).then(res => {
        if(res.data.code!==0)
        {
          this.dialog=false
          return this.$message.error('编辑数据失败')
        }
        this.getAccountList()
        this.dialog=false
        return this.$message.success('编辑数据成功')
      })
      }else{
        delete param.accountId
        charge.addAccountList(param).then(res => {
        if(res.data.code!==0)
        {
          this.dialog=false
          return this.$message.error('添加数据失败')
          }
        this.getAccountList()
        this.dialog=false
        return this.$message.success('添加数据成功')
      })
      }
     }
     else{
       this.$message.error('正确输入内容才能点击确定')
     }
    }
  }
}
</script>

<style lang="less" scoped>
.warp_contrainer {
   padding:3px 20px 50px 20px;
   margin-bottom: 50px;
   }
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.addBt{
  float: right;
  margin: 20px 0 15px 0;
}

</style>


// WEBPACK FOOTER //
// account.vue?61ef224c